/**
 * SearchBar component styles
 * 
 * Contains all CSS classes and style constants for SearchBar component
 * Using Tailwind CSS classes for consistent styling
 */

import React from 'react';

export const searchBarStyles = {
  // Container styles
  container: 'relative w-full max-w-2xl',
  inputWrapper: 'relative flex items-center',
  
  // Input styles
  input: `
    w-full bg-purple-200 py-3 pr-20 pl-12 text-lg border-4 border-red-500 rounded-full font-geist shadow-lg
    focus:border-[#83AA98] focus:outline-none focus:ring-4 focus:ring-#83AA98/20
    hover:border-slate-400 disabled:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-70
    transition-all duration-200
  `,
  inputError: 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200',
  
  // Button styles
  clearButton: `
    absolute right-12 top-1/2 transform -translate-y-1/2 p-2 w-8 h-8
    bg-white hover:bg-slate-100 text-slate-600 hover:text-slate-800
    rounded-full border border-slate-300 hover:border-slate-400 shadow-sm
    focus:outline-none focus:ring-2 focus:ring-[#83AA98] focus:border-[#83AA98]
    transition-all duration-150 font-geist font-medium
  `,
  searchButton: `
    absolute right-3 top-1/2 transform -translate-y-1/2 p-1
    text-slate-400 hover:text-[#83AA98] focus:outline-none focus:text-[#83AA98]
    transition-colors duration-150
  `,
  
  // Loading spinner
  loadingSpinner: 'absolute right-3 top-1/2 transform -translate-y-1/2',
  
  // Accessibility
  srOnly: 'sr-only', // Screen reader only
};

// SVG Icons as React components for better performance and reusability
export const SearchIcons = {
  /**
   * Clear/Close icon (X)
   */
  Clear: () => React.createElement('svg', {
    width: '16',
    height: '16', 
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  }, React.createElement('path', {
    d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
  })),

  /**
   * Search icon (magnifying glass)
   */
  Search: () => React.createElement('svg', {
    width: '16',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  }, React.createElement('path', {
    d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
  })),

  /**
   * Loading spinner
   */
  LoadingSpinner: () => React.createElement('svg', {
    className: 'animate-spin h-5 w-5 text-[#83AA98]',
    viewBox: '0 0 24 24',
    fill: 'none'
  }, [
    React.createElement('circle', {
      key: 'circle',
      cx: '12',
      cy: '12', 
      r: '10',
      stroke: 'currentColor',
      strokeWidth: '4',
      className: 'opacity-25'
    }),
    React.createElement('path', {
      key: 'path',
      className: 'opacity-75',
      fill: 'currentColor',
      d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
    })
  ]),
};